import { useCallback, useState } from "react";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router";
import { PDLButton, PDLTypography } from "../../dna";
import { Logo } from "../../global";
import "./index.scss";

interface LoginorgotPasswordFormProps {
  onSubmit: (email: string) => void;
  loading?: boolean;
}

const ForgotPasswordForm = ({
  onSubmit,
  loading = false,
}: LoginorgotPasswordFormProps) => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    email: "",
  });

  const navigate = useNavigate();

  const validate = () => {
    const newErrors = {
      email: "",
      password: "",
    };

    if (!email) {
      newErrors.email = "O e-mail é obrigatório";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Digite um e-mail válido";
    }

    setErrors(newErrors);

    return !newErrors.email && !newErrors.password;
  };

  const handleLogin = useCallback(async () => {
    if (!validate()) return;

    onSubmit(email);
  }, [email, onSubmit]);

  return (
    <div className="pdl_component_forgot">
      <Logo variant="login" className="mb-5" />

      <Form className="d-grid gap-5">
        <div className="d-grid gap-1">
          <PDLTypography display size="md" weight="semibold">
            Esqueceu a senha?
          </PDLTypography>
          <PDLTypography size="md">
            Vamos enviar um e-mail para redefinir sua senha{" "}
          </PDLTypography>
        </div>

        <div className="d-grid gap-4">
          <div className="d-grid gap-3">
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                value={email}
                onChange={(evt) => setEmail(evt.target.value)}
                autoComplete="email"
                type="text"
                placeholder="Seu e-mail"
                isInvalid={!!errors.email}
                disabled={loading}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </div>

          <div className="d-grid gap-3">
            <PDLButton
              type="button"
              variant="primary"
              onClick={handleLogin}
              size="lg"
            >
              {loading ? <span className="spinner"></span> : "Enviar"}
            </PDLButton>

            <PDLButton
              type="button"
              variant="secondary"
              onClick={() => navigate(-1)}
              size="lg"
            >
              Voltar
            </PDLButton>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ForgotPasswordForm;
